module.exports = "<p>\n  notifications works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/theme/notifications/notifications.component.html
// module id = ../../../../../src/app/theme/notifications/notifications.component.html
// module chunks = main